// SidebarContent.jsx
import { memo, useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import PdfUploadModal from "./PdfUploadModal";

const SidebarContent = ({
  year,
  threads,
  activeThreadId,
  handlePdfUpload,
  onNewThread,
  onSelectThread,
  onLoadMoreThreads,
  hasMoreThreads,
  isMobile = false,
  handleStartCv, 
  isGeneratingCv,
  handleGenerateCvPdf,
  handleCancelCv
}) => {
  const [showUpload, setShowUpload] = useState(false);
  const selectedThread = threads.find((t) => t.id === activeThreadId);
  const isCollectingCvData = selectedThread?.mode === "cv_collect";

  return (
    <div className="d-flex flex-column h-100 px-3 py-3 gap-3 w-100 jacai-sidebar-container">
      <div className="d-flex flex-column gap-3 w-100">
        {
          isCollectingCvData &&
          <Button
            className="jacai-sidebar-btn btn-resume w-100 text-center"
            onClick={handleCancelCv}
          >
              Cancel Generating CV
          </Button>
        }
        {
          !isCollectingCvData &&
          <Button
              className="jacai-sidebar-btn btn-resume w-100 text-center"
              onClick={handleStartCv} disabled={isCollectingCvData}
            >
              Start Generating CV
          </Button>
        }
        {
          selectedThread?.hasCvData && selectedThread.cvStep > 2 && 
          <Button
            className="jacai-sidebar-btn btn-resume w-100 text-center"
            onClick={handleGenerateCvPdf} disabled={isGeneratingCv}
          >
            {isGeneratingCv ? "Generating..." : "Download CV (PDF)"}
          </Button>
        }
        <Button
          className="jacai-sidebar-btn btn-resume w-100 text-center"
          onClick={() => setShowUpload(true)}
        >
          Analyze your resume (PDF)
        </Button>

        <PdfUploadModal
          show={showUpload}
          onClose={() => setShowUpload(false)}
          onFileSelected={handlePdfUpload}
        />
        <Button
          as={Link}
          to="/about-jacai"
          className="jacai-sidebar-btn w-100 text-center"
        >
          About JACAi
        </Button>

        <Button
          as={Link}
          to="/privacy-policy"
          className="jacai-sidebar-btn w-100 text-center"
        >
          Privacy Policy
        </Button>

        <Button
          as={Link}
          to="/terms-of-use"
          className="jacai-sidebar-btn w-100 text-center"
        >
          Terms Of Use
        </Button>
      </div>

      <div className="mt-4 w-100 d-flex flex-column flex-grow-1 overflow-hidden jacai-wrapper">
        <div className="d-flex justify-content-between align-items-center mb-2 px-1">
          <span className="fw-semibold side-bar_text-chats">Chats</span>
          <Button
            size="sm"
            variant="primary"
            className="jacai-new-chat-btn"
            onClick={onNewThread}
          >
            + New
          </Button>
        </div>

        <div
          className="d-flex flex-column gap-2 jacai-scroll"
          onScroll={(e) => {
            if (!hasMoreThreads || !onLoadMoreThreads) return;
            const el = e.currentTarget;
            if (el.scrollTop + el.clientHeight >= el.scrollHeight - 20) {
              onLoadMoreThreads();
            }
          }}
        >
          {threads.map((t) => {
            const isActive = t.id === activeThreadId;
            return (
              <Button
                key={t.id}
                variant={isActive ? "primary" : "outline-primary"}
                className={`jacai-sidebar-btn jacai-chat-btn w-100 text-start ${
                  isActive ? "active" : ""
                }`}
                onClick={() => onSelectThread(t.id)}
              >
                {t.title}
              </Button>
            );
          })}
        </div>
      </div>

      {!isMobile && (
        <div className="mt-auto text-center pt-3 jacai-sidebar-footer">
          <small>© {year} JACAi</small>
        </div>
      )}
    </div>
  );
};

export default memo(SidebarContent);